// Dependencies
import React from 'react';
import radium from 'radium';
import {ThemeContext} from "../../../components/theme/Theme.jsx";
import history from "../../../lib/history";
import Button from "../../../components/button/Button";
import ButtonEventsOverview from "../../../components/button-events-overview/ButtonEventsOverview";

function CHECKOUT_SC_EXPIRED(props) {
	const context = React.useContext(ThemeContext)
	const style = {
		container: {
			margin: 'auto',
		},
		error: {
			fontWeight: '600',
			textAlign: 'center',
		},
		buttonContainer: {
			marginTop: '3em',
		},
	};

	const eventSpecific = !!props.checkoutProps.output.selectedEventUuid;

	function navigateToStartPage() {
		history.push(`${props.checkoutProps.output.selectedEventUuid}`);
	}

	return (
		<div style={style.container}>
			<div style={style.error}
				dangerouslySetInnerHTML={{
					__html: context.themeManager.getThemeTextOrHardcodedDefault('checkoutSCExpiredText'),
				}}/>
			{eventSpecific &&
			<Button
				name="to_startpage"
				buttonText={context.themeManager.getThemeTextOrHardcodedDefault('goToStartPageBtnLabel')}
				btnStyle="highlight"
				onClick={navigateToStartPage}
				buttonContainerStyle={style.buttonContainer}
			/>
			}
			{!eventSpecific &&
			<ButtonEventsOverview
				btnText={context.themeManager.getThemeTextOrHardcodedDefault('goToEventOverviewBtnLabel')}
				buttonContainerStyle={style.buttonContainer}
				iconName="angle-double-left"
			/>
			}
		</div>
	);
}
const RadiumCHECKOUT_SC_EXPIRED = radium(CHECKOUT_SC_EXPIRED);

/* if component is using radium set name (name is used in CheckoutDispatcherPage) */
RadiumCHECKOUT_SC_EXPIRED.name = CHECKOUT_SC_EXPIRED.name
export default RadiumCHECKOUT_SC_EXPIRED;
